import GenericError from "./error";

export default function Custom404() {
  return <GenericError label="Page not found." />;
}
